import { useTranslation } from 'react-i18next'

import { FieldCategoryRow, FieldSkeleton } from '@/components/layout/field-row'

import { PlaceFeatureKey } from '../../features/places-features.constants'

interface PlaceFeatureRowSkeletonProps {
  customLabel?: string
  depth?: number
  featureKey: PlaceFeatureKey
}

// Note: the label is static, only the value is a skeleton - the size of the loaded small On / Off
// badge: 2.4rem tall (1.6rem line-height + 2 * 0.4rem padding), about 5.2rem wide (text + 2 * 1.6rem padding)
export const PlaceFeatureRowSkeleton = ({
  customLabel,
  depth = 0,
  featureKey,
}: PlaceFeatureRowSkeletonProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <FieldCategoryRow
      depth={depth}
      label={customLabel ?? t(`organisation:places.building.toggles.${featureKey}`)}
    >
      <FieldSkeleton height="2.4rem" width="5.2rem" />
    </FieldCategoryRow>
  )
}
